/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ app: NonNullable<unknown> }} Mcp_Connect_Approved_NoteInputs */

const en_mcp_connect_approved_note = /** @type {(inputs: Mcp_Connect_Approved_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Once ${i?.app} confirms the connection, you can close this window. You can disconnect Listening from ${i?.app} at any time.`)
};

const es_mcp_connect_approved_note = /** @type {(inputs: Mcp_Connect_Approved_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cuando ${i?.app} confirme la conexión, puedes cerrar esta ventana. Puedes desconectar Listening de ${i?.app} en cualquier momento.`)
};

/**
* | output |
* | --- |
* | "Once {app} confirms the connection, you can close this window. You can disconnect Listening from {app} at any time." |
*
* @param {Mcp_Connect_Approved_NoteInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_connect_approved_note = /** @type {((inputs: Mcp_Connect_Approved_NoteInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Connect_Approved_NoteInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_connect_approved_note(inputs)
	return en_mcp_connect_approved_note(inputs)
});